(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bm-contact-form]').forEach((form) => {
    const firstName = form.querySelector('[data-bm-contact-first-name]');
    const lastName = form.querySelector('[data-bm-contact-last-name]');
    const fullName = form.querySelector('[data-bm-contact-full-name]');

    const syncName = () => {
      if (!firstName || !lastName || !fullName) return;
      fullName.value = `${firstName.value.trim()} ${lastName.value.trim()}`.trim();
    };

    firstName?.addEventListener('input', syncName);
    lastName?.addEventListener('input', syncName);

    form.addEventListener('submit', () => {
      syncName();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
